import React from "react";

const PromotionalTwo = () => {
  return (
    <section className="sx-service-section">
      <div className="sx-service-container">
        {/* RIGHT IMAGE */}
        <div className="sx-service-form-wrap">
          <img
            src="/assets/images/bg/banner2.png"
            alt="Smart Printer Control"
            style={{ width: "100%", height: "auto" }}
          />
        </div>

        {/* LEFT CONTENT */}
        <div className="sx-service-content">
          <span className="sx-service-label">Our Services</span>

          <h2 className="sx-service-title">What We Help With</h2>

          <p className="sx-service-text">
            Our services are designed to ensure your printer works reliably,
            securely, and efficiently in daily use whether at home or in a
            professional environment.
          </p>

          <ul className="sx-service-points">
            <li>
              <strong>New Printer Installation</strong>
              <br />
              Complete setup from unboxing to the first successful print, making
              sure your printer is configured correctly from day one.
            </li>

            <li>
              <strong>Network & Wireless Setup</strong>
              <br />
              Wi-Fi configuration, multi-device connectivity, and stable network
              setup for seamless printing across all your devices.
            </li>

            <li>
              <strong>Error Resolution</strong>
              <br />
              Resolving offline errors, paper jams, slow printing, driver
              conflicts, and print quality issues quickly and effectively.
            </li>
          </ul>
        </div>
      </div>

      {/* CSS */}
      <style>{`
        /* ================= SECTION ================= */
        .sx-service-section {
          padding: 60px 0;
          background: #f9fafb;
        }

        .sx-service-container {
          max-width: 1200px;
          margin: auto;
          padding: 0 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 60px;
        }

        /* ================= LEFT CONTENT ================= */
        .sx-service-content {
          max-width: 55%;
        }

        .sx-service-label {
          display: inline-block;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 1px;
          color: #2563eb;
          text-transform: uppercase;
          margin-bottom: 14px;
        }

        .sx-service-title {
          font-size: 38px;
          font-weight: 800;
          line-height: 1.25;
          color: #111827;
          margin-bottom: 20px;
        }

        .sx-service-text {
          font-size: 16px;
          line-height: 1.7;
          color: #4b5563;
          margin-bottom: 18px;
          max-width: 560px;
        }

        .sx-service-points {
          list-style: none;
          padding: 0;
          margin-top: 22px;
        }

        .sx-service-points li {
          font-size: 15px;
          font-weight: 500;
          color: #1f2937;
          margin-bottom: 16px;
          line-height: 1.6;
        }

        .sx-service-points strong {
          font-weight: 700;
          color: #111827;
        }

        /* ================= IMAGE ================= */
        .sx-service-form-wrap {
          max-width: 420px;
          width: 100%;
        }

        /* ================= MOBILE ================= */
        @media (max-width: 900px) {
          .sx-service-container {
            flex-direction: column;
          }

          .sx-service-content,
          .sx-service-form-wrap {
            max-width: 100%;
          }

          .sx-service-title {
            font-size: 30px;
          }
        }
      `}</style>
    </section>
  );
};

export default PromotionalTwo;
